import { render } from "./StepThankYou.vue?vue&type=template&id=491e5b49"
import script from "./StepThankYou.vue?vue&type=script&lang=js"
export * from "./StepThankYou.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__